module.exports = __webpack_public_path__ + "img/cable.0a381ad2.svg";